<template>
  <div class="container-fluid" v-if="this.$store.state.globalMessage.message.text">
    <div class="row">
    <div class="card text-xs-center z-depth-2" v-bind:class="className">
      <div class="card-block">
        <p class="white-text">{{this.$store.state.globalMessage.message.text}}</p>
      </div>
      <button class="dismissBtn" v-on:click="dismiss"><i class="fa fa-times" aria-hidden="true"></i></button>
    </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'GlobalMessage',
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    dismiss() {
      this.$store.dispatch('unsetGlobalMessage');
    },
  },
  computed: {
    className() {
      if (this.$store.state.globalMessage.message.className !== false) {
        return `card-${this.$store.state.globalMessage.message.className}`;
      }
      return '';
    },
  },
  watch: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.card {
  position: fixed;
  bottom: 0;
  padding-right: 50px;
  z-index: 1000;
  margin-bottom: 0;
}
.dismissBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  border: 0;
  background: transparent;
  color: white;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// GlobalMessage.vue?585c66ce